"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bologna": {
    "08159c1b": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }],
    "20bb015b": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "24536ebf": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }],
    "28f32a8d": [{
      "hkey": "d80cd525",
      "slug": "navile-lame-pescarola",
      "name": "Navile-Lame-Pescarola",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "skipSearch": null
    }],
    "2db0b61d": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "853e62a4",
      "slug": "massarenti-san-vitale-roveri",
      "name": "Massarenti, San Vitale-Roveri",
      "primary": false,
      "skipSearch": null
    }],
    "2e5348d1": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "skipSearch": false
    }],
    "3362e3a1": [{
      "hkey": "035cb1f0",
      "slug": "costa-saragozza",
      "name": "Costa Saragozza",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d2a360ef",
      "slug": "murri",
      "name": "Murri",
      "primary": true,
      "skipSearch": null
    }],
    "3e0051bb": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "853e62a4",
      "slug": "massarenti-san-vitale-roveri",
      "name": "Massarenti, San Vitale-Roveri",
      "primary": false,
      "skipSearch": null
    }],
    "48259080": [{
      "hkey": "d80cd525",
      "slug": "navile-lame-pescarola",
      "name": "Navile-Lame-Pescarola",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "skipSearch": null
    }],
    "49f9e138": [{
      "hkey": "d80cd525",
      "slug": "navile-lame-pescarola",
      "name": "Navile-Lame-Pescarola",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "skipSearch": null
    }],
    "4eb102f1": [{
      "hkey": "f34c3a6d",
      "slug": "san-donato-pilastro",
      "name": "San Donato, Pilastro",
      "primary": true,
      "skipSearch": false
    }],
    "57154366": [{
      "hkey": "9672cb12",
      "slug": "borgo-panigale-aeroporto",
      "name": "Borgo Panigale, Aeroporto",
      "primary": true,
      "skipSearch": null
    }],
    "59e1e9df": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }],
    "5ec3e190": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }],
    "6114eb52": [{
      "hkey": "f34c3a6d",
      "slug": "san-donato-pilastro",
      "name": "San Donato, Pilastro",
      "primary": true,
      "skipSearch": null
    }],
    "63b811da": [{
      "hkey": "035cb1f0",
      "slug": "costa-saragozza",
      "name": "Costa Saragozza",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "6f1d7247",
      "slug": "barca-santa-viola",
      "name": "Barca, Santa Viola",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "a02d857f",
      "slug": "saffi",
      "name": "Saffi",
      "primary": false,
      "skipSearch": null
    }],
    "6b53c72f": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "6be3c045": [{
      "hkey": "6f1d7247",
      "slug": "barca-santa-viola",
      "name": "Barca, Santa Viola",
      "primary": true,
      "skipSearch": false
    }],
    "6bf9c836": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "6d99e4a0": [{
      "hkey": "9672cb12",
      "slug": "borgo-panigale-aeroporto",
      "name": "Borgo Panigale, Aeroporto",
      "primary": true,
      "skipSearch": false
    }],
    "6fcd4f48": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "853e62a4",
      "slug": "massarenti-san-vitale-roveri",
      "name": "Massarenti, San Vitale-Roveri",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d2a360ef",
      "slug": "murri",
      "name": "Murri",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "ef65ae5b",
      "slug": "san-vitale-massarenti-roveri",
      "name": "San Vitale, Massarenti Roveri",
      "primary": false,
      "skipSearch": null
    }],
    "710407fd": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "853e62a4",
      "slug": "massarenti-san-vitale-roveri",
      "name": "Massarenti, San Vitale-Roveri",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d2a360ef",
      "slug": "murri",
      "name": "Murri",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "ef65ae5b",
      "slug": "san-vitale-massarenti-roveri",
      "name": "San Vitale, Massarenti Roveri",
      "primary": false,
      "skipSearch": null
    }],
    "8149dbd8": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "883bf292": [{
      "hkey": "6f1d7247",
      "slug": "barca-santa-viola",
      "name": "Barca, Santa Viola",
      "primary": true,
      "skipSearch": false
    }],
    "8b81f69b": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }],
    "8bc92b35": [{
      "hkey": "6f1d7247",
      "slug": "barca-santa-viola",
      "name": "Barca, Santa Viola",
      "primary": true,
      "skipSearch": false
    }],
    "981a4fe0": [{
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "skipSearch": false
    }],
    "9e195b31": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "skipSearch": null
    }],
    "a9e4264c": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "skipSearch": false
    }],
    "a9ebfca4": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "853e62a4",
      "slug": "massarenti-san-vitale-roveri",
      "name": "Massarenti, San Vitale-Roveri",
      "primary": false,
      "skipSearch": null
    }],
    "aeroporto-borgo-panigale": [{
      "hkey": "9672cb12",
      "slug": "borgo-panigale-aeroporto",
      "name": "Borgo Panigale, Aeroporto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "aff5c126": [{
      "hkey": "035cb1f0",
      "slug": "costa-saragozza",
      "name": "Costa Saragozza",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "a02d857f",
      "slug": "saffi",
      "name": "Saffi",
      "primary": false,
      "skipSearch": null
    }],
    "b49ca7e6": [{
      "hkey": "035cb1f0",
      "slug": "costa-saragozza",
      "name": "Costa Saragozza",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "a02d857f",
      "slug": "saffi",
      "name": "Saffi",
      "primary": false,
      "skipSearch": null
    }],
    "ba4322a1": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "853e62a4",
      "slug": "massarenti-san-vitale-roveri",
      "name": "Massarenti, San Vitale-Roveri",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d2a360ef",
      "slug": "murri",
      "name": "Murri",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "ef65ae5b",
      "slug": "san-vitale-massarenti-roveri",
      "name": "San Vitale, Massarenti Roveri",
      "primary": false,
      "skipSearch": null
    }],
    "barca": [{
      "hkey": "6f1d7247",
      "slug": "barca-santa-viola",
      "name": "Barca, Santa Viola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bologna"
    }],
    "be043baf": [{
      "hkey": "9672cb12",
      "slug": "borgo-panigale-aeroporto",
      "name": "Borgo Panigale, Aeroporto",
      "primary": true,
      "skipSearch": null
    }],
    "bellaria-savena": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bolognina": [{
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bologna"
    }],
    "bolognina-corticella-pescarola": [{
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "borgo-panigale": [{
      "hkey": "9672cb12",
      "slug": "borgo-panigale-aeroporto",
      "name": "Borgo Panigale, Aeroporto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "borgo-panigale-aereoporto": [{
      "hkey": "9672cb12",
      "slug": "borgo-panigale-aeroporto",
      "name": "Borgo Panigale, Aeroporto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c02f001d": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }],
    "c8cc1f1d": [{
      "hkey": "d80cd525",
      "slug": "navile-lame-pescarola",
      "name": "Navile-Lame-Pescarola",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "f34c3a6d",
      "slug": "san-donato-pilastro",
      "name": "San Donato, Pilastro",
      "primary": false,
      "skipSearch": null
    }],
    "ccf81ddc": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "853e62a4",
      "slug": "massarenti-san-vitale-roveri",
      "name": "Massarenti, San Vitale-Roveri",
      "primary": false,
      "skipSearch": null
    }],
    "centro": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "centro-irnerio": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bologna"
    }],
    "centro-malpighi": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bologna"
    }],
    "centro-marconi": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bologna"
    }],
    "colli-castiglione-san-mamolo": [{
      "hkey": "d2a360ef",
      "slug": "murri",
      "name": "Murri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "colli-ravone-san-luca": [{
      "hkey": "d2a360ef",
      "slug": "murri",
      "name": "Murri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "colli-san-ruffillo": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bologna"
    }],
    "corticella": [{
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bologna"
    }],
    "corticella-ippodromo": [{
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "costa-saragozza-saffi": [{
      "hkey": "035cb1f0",
      "slug": "costa-saragozza",
      "name": "Costa Saragozza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d4cd9ccd": [{
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "skipSearch": false
    }],
    "d6b2bd2e": [{
      "hkey": "035cb1f0",
      "slug": "costa-saragozza",
      "name": "Costa Saragozza",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d2a360ef",
      "slug": "murri",
      "name": "Murri",
      "primary": true,
      "skipSearch": null
    }],
    "dc143462": [{
      "hkey": "d80cd525",
      "slug": "navile-lame-pescarola",
      "name": "Navile-Lame-Pescarola",
      "primary": true,
      "skipSearch": false
    }],
    "dfc7f343": [{
      "hkey": "853e62a4",
      "slug": "massarenti-san-vitale-roveri",
      "name": "Massarenti, San Vitale-Roveri",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "d2a360ef",
      "slug": "murri",
      "name": "Murri",
      "primary": false,
      "skipSearch": false
    }],
    "ebb9ed37": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "skipSearch": null
    }],
    "ef379940": [{
      "hkey": "035cb1f0",
      "slug": "costa-saragozza",
      "name": "Costa Saragozza",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "a02d857f",
      "slug": "saffi",
      "name": "Saffi",
      "primary": false,
      "skipSearch": false
    }],
    "ef65ae5b": [{
      "hkey": "853e62a4",
      "slug": "massarenti-san-vitale-roveri",
      "name": "Massarenti, San Vitale-Roveri",
      "primary": true,
      "skipSearch": false
    }],
    "f2608c43": [{
      "hkey": "d80cd525",
      "slug": "navile-lame-pescarola",
      "name": "Navile-Lame-Pescarola",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "skipSearch": null
    }],
    "f3d0f342": [{
      "hkey": "035cb1f0",
      "slug": "costa-saragozza",
      "name": "Costa Saragozza",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "d2a360ef",
      "slug": "murri",
      "name": "Murri",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "ef65ae5b",
      "slug": "san-vitale-massarenti-roveri",
      "name": "San Vitale, Massarenti Roveri",
      "primary": false,
      "skipSearch": null
    }],
    "galvani": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "galvani-santo-stefano": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bologna"
    }],
    "irnerio": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "lame-pescarola": [{
      "hkey": "d80cd525",
      "slug": "navile-lame-pescarola",
      "name": "Navile-Lame-Pescarola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bologna"
    }],
    "malpighi": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "marconi": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "mazzini-fossolo": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bologna"
    }],
    "mazzini-s-orsola": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "murri-giardini-margherita": [{
      "hkey": "ef65ae5b",
      "slug": "san-vitale-massarenti-roveri",
      "name": "San Vitale, Massarenti Roveri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "murri-massarenti": [{
      "hkey": "853e62a4",
      "slug": "massarenti-san-vitale-roveri",
      "name": "Massarenti, San Vitale-Roveri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "navile": [{
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "porto": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "reno": [{
      "hkey": "6f1d7247",
      "slug": "barca-santa-viola",
      "name": "Barca, Santa Viola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "saffi-s-viola": [{
      "hkey": "6f1d7247",
      "slug": "barca-santa-viola",
      "name": "Barca, Santa Viola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-donato": [{
      "hkey": "f34c3a6d",
      "slug": "san-donato-pilastro",
      "name": "San Donato, Pilastro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-donato-pilastro-fiera": [{
      "hkey": "f34c3a6d",
      "slug": "san-donato-pilastro",
      "name": "San Donato, Pilastro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "santa-viola": [{
      "hkey": "6f1d7247",
      "slug": "barca-santa-viola",
      "name": "Barca, Santa Viola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bologna"
    }],
    "santo-stefano": [{
      "hkey": "12d65861",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-vitale": [{
      "hkey": "ef65ae5b",
      "slug": "san-vitale-massarenti-roveri",
      "name": "San Vitale, Massarenti Roveri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-vitale-massarenti-roveri": [{
      "hkey": "853e62a4",
      "slug": "massarenti-san-vitale-roveri",
      "name": "Massarenti, San Vitale-Roveri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bologna"
    }],
    "san-vitale-mazzini-fossolo": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "saragozza": [{
      "hkey": "035cb1f0",
      "slug": "costa-saragozza",
      "name": "Costa Saragozza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "savena": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "s-donato-fiera": [{
      "hkey": "f34c3a6d",
      "slug": "san-donato-pilastro",
      "name": "San Donato, Pilastro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "s-vitale-galvani": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "s-vitale-massarenti": [{
      "hkey": "ef65ae5b",
      "slug": "san-vitale-massarenti-roveri",
      "name": "San Vitale, Massarenti Roveri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "toscana-savena": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "toscana-s-ruffillo": [{
      "hkey": "2fed3732",
      "slug": "due-madonne-savena-san-ruffillo-monte-donato-fossolo-mazzini",
      "name": "Due Madonne-Savena, San Ruffillo-Monte Donato, Fossolo, Mazzini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "zanardi": [{
      "hkey": "eba0add4",
      "slug": "bolognina-corticella-arcoveggio-ippodromo",
      "name": "Bolognina, Corticella, Arcoveggio Ippodromo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  },
  "genova": {
    "07b337fa": [{
      "hkey": "0d8595f9",
      "slug": "voltri-alture",
      "name": "Voltri alture",
      "primary": true,
      "skipSearch": false
    }],
    "1b2f746d": [{
      "hkey": "bb72395a",
      "slug": "marassi-quezzi",
      "name": "Marassi, Quezzi",
      "primary": true,
      "skipSearch": false
    }],
    "4ad30c39": [{
      "hkey": "03b1133c",
      "slug": "quinto-nervi",
      "name": "Quinto, Nervi",
      "primary": true,
      "skipSearch": false
    }],
    "4f4dfdd7": [{
      "hkey": "eb3aa27d",
      "slug": "san-fruttuoso",
      "name": "San Fruttuoso",
      "primary": true,
      "skipSearch": false
    }],
    "623e5904": [{
      "hkey": "647e4221",
      "slug": "centro-carignano-portoria",
      "name": "Centro, Carignano, Portoria",
      "primary": true,
      "skipSearch": false
    }],
    "8991b875": [{
      "hkey": "7171d738",
      "slug": "bolzaneto",
      "name": "Bolzaneto",
      "primary": true,
      "skipSearch": false
    }],
    "93e30bc5": [{
      "hkey": "554b74a9",
      "slug": "sturla-quarto",
      "name": "Sturla, Quarto",
      "primary": true,
      "skipSearch": false
    }],
    "995eb0fc": [{
      "hkey": "c5689cff",
      "slug": "rivarolo",
      "name": "Rivarolo",
      "primary": true,
      "skipSearch": false
    }],
    "9a1db13e": [{
      "hkey": "bb72395a",
      "slug": "marassi-quezzi",
      "name": "Marassi, Quezzi",
      "primary": true,
      "skipSearch": false
    }],
    "a862a791": [{
      "hkey": "ec59c881",
      "slug": "borgoratti-apparizione",
      "name": "Borgoratti, Apparizione",
      "primary": true,
      "skipSearch": false
    }],
    "bolzaneto-teglia": [{
      "hkey": "7171d738",
      "slug": "bolzaneto",
      "name": "Bolzaneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "borgoratti": [{
      "hkey": "ec59c881",
      "slug": "borgoratti-apparizione",
      "name": "Borgoratti, Apparizione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c0126dff": [{
      "hkey": "4db0fa9a",
      "slug": "principe-san-teodoro",
      "name": "Principe, San Teodoro",
      "primary": true,
      "skipSearch": false
    }],
    "carignano": [{
      "hkey": "647e4221",
      "slug": "centro-carignano-portoria",
      "name": "Centro, Carignano, Portoria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "centro": [{
      "hkey": "647e4221",
      "slug": "centro-carignano-portoria",
      "name": "Centro, Carignano, Portoria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cf8eddf4": [{
      "hkey": "03b1133c",
      "slug": "quinto-nervi",
      "name": "Quinto, Nervi",
      "primary": true,
      "skipSearch": false
    }],
    "d31c1c19": [{
      "hkey": "554b74a9",
      "slug": "sturla-quarto",
      "name": "Sturla, Quarto",
      "primary": true,
      "skipSearch": false
    }],
    "d91d0168": [{
      "hkey": "647e4221",
      "slug": "centro-carignano-portoria",
      "name": "Centro, Carignano, Portoria",
      "primary": true,
      "skipSearch": false
    }],
    "efedc72c": [{
      "hkey": "4db0fa9a",
      "slug": "principe-san-teodoro",
      "name": "Principe, San Teodoro",
      "primary": true,
      "skipSearch": false
    }],
    "fadc928e": [{
      "hkey": "70eb4855",
      "slug": "san-martino",
      "name": "San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "marassi": [{
      "hkey": "bb72395a",
      "slug": "marassi-quezzi",
      "name": "Marassi, Quezzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "nervi": [{
      "hkey": "03b1133c",
      "slug": "quinto-nervi",
      "name": "Quinto, Nervi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "principe": [{
      "hkey": "4db0fa9a",
      "slug": "principe-san-teodoro",
      "name": "Principe, San Teodoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "quarto": [{
      "hkey": "554b74a9",
      "slug": "sturla-quarto",
      "name": "Sturla, Quarto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "quezzi": [{
      "hkey": "bb72395a",
      "slug": "marassi-quezzi",
      "name": "Marassi, Quezzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "quinto": [{
      "hkey": "03b1133c",
      "slug": "quinto-nervi",
      "name": "Quinto, Nervi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "rivarolo-san-quirico": [{
      "hkey": "c5689cff",
      "slug": "rivarolo",
      "name": "Rivarolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-teodoro-di-negro": [{
      "hkey": "4db0fa9a",
      "slug": "principe-san-teodoro",
      "name": "Principe, San Teodoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "s-fruttuoso": [{
      "hkey": "eb3aa27d",
      "slug": "san-fruttuoso",
      "name": "San Fruttuoso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "s-martino": [{
      "hkey": "70eb4855",
      "slug": "san-martino",
      "name": "San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "sturla": [{
      "hkey": "554b74a9",
      "slug": "sturla-quarto",
      "name": "Sturla, Quarto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "voltri-alture-acquasanta-fabbriche-mele": [{
      "hkey": "0d8595f9",
      "slug": "voltri-alture",
      "name": "Voltri alture",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }]
  },
  "monza": {
    "1e5b820a": [{
      "hkey": "e709c467",
      "slug": "cazzaniga-ospedale-viale-elvezia",
      "name": "Cazzaniga, Ospedale, Viale Elvezia",
      "primary": false,
      "skipSearch": false
    }],
    "36f65726": [{
      "hkey": "e709c467",
      "slug": "cazzaniga-ospedale-viale-elvezia",
      "name": "Cazzaniga, Ospedale, Viale Elvezia",
      "primary": false,
      "skipSearch": false
    }],
    "3d06b3a7": [{
      "hkey": "ba0e67e5",
      "slug": "san-giuseppe-triante",
      "name": "San Giuseppe, Triante",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "e709c467",
      "slug": "cazzaniga-ospedale-viale-elvezia",
      "name": "Cazzaniga, Ospedale, Viale Elvezia",
      "primary": false,
      "skipSearch": false
    }],
    "47361210": [{
      "hkey": "6bd48fc6",
      "slug": "san-rocco-sant-alessandro",
      "name": "San Rocco, Sant'Alessandro",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "e709c467",
      "slug": "cazzaniga-ospedale-viale-elvezia",
      "name": "Cazzaniga, Ospedale, Viale Elvezia",
      "primary": false,
      "skipSearch": false
    }],
    "4c994bd2": [{
      "hkey": "9728a9fa",
      "slug": "cederna-cantalupo-stadio",
      "name": "Cederna, Cantalupo, Stadio",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "e709c467",
      "slug": "cazzaniga-ospedale-viale-elvezia",
      "name": "Cazzaniga, Ospedale, Viale Elvezia",
      "primary": false,
      "skipSearch": false
    }],
    "5eb3b41a": [{
      "hkey": "b480d514",
      "slug": "san-biagio-san-carlo-stazione",
      "name": "San Biagio, San Carlo, Stazione",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "e709c467",
      "slug": "cazzaniga-ospedale-viale-elvezia",
      "name": "Cazzaniga, Ospedale, Viale Elvezia",
      "primary": false,
      "skipSearch": false
    }],
    "6f154b47": [{
      "hkey": "9728a9fa",
      "slug": "cederna-cantalupo-stadio",
      "name": "Cederna, Cantalupo, Stadio",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "e709c467",
      "slug": "cazzaniga-ospedale-viale-elvezia",
      "name": "Cazzaniga, Ospedale, Viale Elvezia",
      "primary": false,
      "skipSearch": false
    }],
    "amati-buonarroti-cederna-santalbino": [{
      "hkey": "cc326da0",
      "slug": "san-donato-buonarroti",
      "name": "San Donato, Buonarroti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monza"
    }],
    "dc0abb73": [{
      "hkey": "9728a9fa",
      "slug": "cederna-cantalupo-stadio",
      "name": "Cederna, Cantalupo, Stadio",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "08b9d9f0",
      "slug": "sant-albino-cascine-bastoni",
      "name": "Sant'Albino, Cascine Bastoni",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "6ff60b18",
      "slug": "viale-liberta",
      "name": "Viale Libertà",
      "primary": false,
      "skipSearch": false
    }],
    "f2067ad9": [{
      "hkey": "cc326da0",
      "slug": "san-donato-buonarroti",
      "name": "San Donato, Buonarroti",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "b480d514",
      "slug": "san-biagio-san-carlo-stazione",
      "name": "San Biagio, San Carlo, Stazione",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "9728a9fa",
      "slug": "cederna-cantalupo-stadio",
      "name": "Cederna, Cantalupo, Stadio",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "55b2c87c",
      "slug": "regina-pacis-sant-ambrogio",
      "name": "Regina Pacis, Sant'Ambrogio",
      "primary": false,
      "skipSearch": false
    }],
    "centro-storico-san-gerardo-liberta": [{
      "hkey": "06823739",
      "slug": "centro-san-gerardo",
      "name": "Centro, San Gerardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monza"
    }],
    "64a01c31": [{
      "hkey": "e709c467",
      "slug": "cazzaniga-ospedale-viale-elvezia",
      "name": "Cazzaniga, Ospedale, Viale Elvezia",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "b88ecaf5",
      "slug": "san-fruttuoso-taccona",
      "name": "San Fruttuoso, Taccona",
      "primary": true,
      "skipSearch": false
    }],
    "san-fruttuoso-boscherona-taccona": [{
      "hkey": "b88ecaf5",
      "slug": "san-fruttuoso-taccona",
      "name": "San Fruttuoso, Taccona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monza"
    }],
    "fd657ec9": [{
      "hkey": "9728a9fa",
      "slug": "cederna-cantalupo-stadio",
      "name": "Cederna, Cantalupo, Stadio",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "b480d514",
      "slug": "san-biagio-san-carlo-stazione",
      "name": "San Biagio, San Carlo, Stazione",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "e709c467",
      "slug": "cazzaniga-ospedale-viale-elvezia",
      "name": "Cazzaniga, Ospedale, Viale Elvezia",
      "primary": false,
      "skipSearch": false
    }],
    "musicisti": [{
      "hkey": "06823739",
      "slug": "centro-san-gerardo",
      "name": "Centro, San Gerardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monza"
    }],
    "parco-vedano": [{
      "hkey": "06823739",
      "slug": "centro-san-gerardo",
      "name": "Centro, San Gerardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monza"
    }],
    "parco-via-lecco": [{
      "hkey": "6ff60b18",
      "slug": "viale-liberta",
      "name": "Viale Libertà",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monza"
    }],
    "san-biagio-cazzaniga": [{
      "hkey": "b480d514",
      "slug": "san-biagio-san-carlo-stazione",
      "name": "San Biagio, San Carlo, Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-fruttuoso-triante-san-carlo-san-giuseppe": [{
      "hkey": "ba0e67e5",
      "slug": "san-giuseppe-triante",
      "name": "San Giuseppe, Triante",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-rocco-casignolo-santalessandro": [{
      "hkey": "6bd48fc6",
      "slug": "san-rocco-sant-alessandro",
      "name": "San Rocco, Sant'Alessandro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-damiano-buonarroti-regina-pacis": [{
      "hkey": "cc326da0",
      "slug": "san-donato-buonarroti",
      "name": "San Donato, Buonarroti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monza"
    }],
    "7ba267bd": [{
      "hkey": "e709c467",
      "slug": "cazzaniga-ospedale-viale-elvezia",
      "name": "Cazzaniga, Ospedale, Viale Elvezia",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "b480d514",
      "slug": "san-biagio-san-carlo-stazione",
      "name": "San Biagio, San Carlo, Stazione",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "06823739",
      "slug": "centro-san-gerardo",
      "name": "Centro, San Gerardo",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "9917ff0d",
      "slug": "monza-parco",
      "name": "Monza Parco",
      "primary": false,
      "skipSearch": false
    }],
    "centro-parco-boschetti-reali": [{
      "hkey": "06823739",
      "slug": "centro-san-gerardo",
      "name": "Centro, San Gerardo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monza"
    }],
    "sant-albino-cascine-bastoni-cederna": [{
      "hkey": "08b9d9f0",
      "slug": "sant-albino-cascine-bastoni",
      "name": "Sant'Albino, Cascine Bastoni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monza"
    }],
    "d99732a3": [{
      "hkey": "ba0e67e5",
      "slug": "san-giuseppe-triante",
      "name": "San Giuseppe, Triante",
      "primary": true,
      "skipSearch": false
    }],
    "triante-san-giuseppe": [{
      "hkey": "ba0e67e5",
      "slug": "san-giuseppe-triante",
      "name": "San Giuseppe, Triante",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f347ed45": [{
      "hkey": "9728a9fa",
      "slug": "cederna-cantalupo-stadio",
      "name": "Cederna, Cantalupo, Stadio",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "06823739",
      "slug": "centro-san-gerardo",
      "name": "Centro, San Gerardo",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "55b2c87c",
      "slug": "regina-pacis-sant-ambrogio",
      "name": "Regina Pacis, Sant'Ambrogio",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "6ff60b18",
      "slug": "viale-liberta",
      "name": "Viale Libertà",
      "primary": true,
      "skipSearch": false
    }],
    "via-lecco-viale-liberta-amati-stadio": [{
      "hkey": "6ff60b18",
      "slug": "viale-liberta",
      "name": "Viale Libertà",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monza"
    }]
  },
  "napoli": {
    "002af5db": [{
      "hkey": "228c3d7e",
      "slug": "agnano-bagnoli-fuorigrotta",
      "name": "Agnano, Bagnoli, Fuorigrotta",
      "primary": true,
      "skipSearch": false
    }],
    "043ab069": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "0d78f2fa": [{
      "hkey": "864b0f88",
      "slug": "posillipo-marechiaro",
      "name": "Posillipo, Marechiaro",
      "primary": true,
      "skipSearch": false
    }],
    "10495e79": [{
      "hkey": "066dc074",
      "slug": "ponti-rossi-san-carlo-all-arena",
      "name": "Ponti Rossi, San Carlo all'Arena",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "ac6285ee",
      "slug": "stella-sanita",
      "name": "Stella, Sanità",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "bf9ea218",
      "slug": "avvocata-materdei",
      "name": "Avvocata, Materdei",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "1835b7f0": [{
      "hkey": "228c3d7e",
      "slug": "agnano-bagnoli-fuorigrotta",
      "name": "Agnano, Bagnoli, Fuorigrotta",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "2563f814": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "2e057759": [{
      "hkey": "5abb4536",
      "slug": "chiaiano",
      "name": "Chiaiano",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "d368949d",
      "slug": "miano-piscinola",
      "name": "Miano, Piscinola",
      "primary": false,
      "skipSearch": false
    }],
    "32474f47": [{
      "hkey": "066dc074",
      "slug": "ponti-rossi-san-carlo-all-arena",
      "name": "Ponti Rossi, San Carlo all'Arena",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "ac6285ee",
      "slug": "stella-sanita",
      "name": "Stella, Sanità",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "bf9ea218",
      "slug": "avvocata-materdei",
      "name": "Avvocata, Materdei",
      "primary": false,
      "skipSearch": null
    }],
    "32721e4f": [{
      "hkey": "228c3d7e",
      "slug": "agnano-bagnoli-fuorigrotta",
      "name": "Agnano, Bagnoli, Fuorigrotta",
      "primary": true,
      "skipSearch": null
    }],
    "3a3eb595": [{
      "hkey": "0d003e10",
      "slug": "ponticelli",
      "name": "Ponticelli",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "cb8edfa3",
      "slug": "barra-san-giovanni-a-teduccio",
      "name": "Barra, San Giovanni a Teduccio",
      "primary": true,
      "skipSearch": false
    }],
    "40976d25": [{
      "hkey": "228c3d7e",
      "slug": "agnano-bagnoli-fuorigrotta",
      "name": "Agnano, Bagnoli, Fuorigrotta",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "42208886": [{
      "hkey": "567fc66c",
      "slug": "arenella",
      "name": "Arenella",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "75459368",
      "slug": "vomero",
      "name": "Vomero",
      "primary": true,
      "skipSearch": false
    }],
    "44a92a90": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": false
    }],
    "4d80f9aa": [{
      "hkey": "0d003e10",
      "slug": "ponticelli",
      "name": "Ponticelli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "cb8edfa3",
      "slug": "barra-san-giovanni-a-teduccio",
      "name": "Barra, San Giovanni a Teduccio",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "519c8f75": [{
      "hkey": "5abb4536",
      "slug": "chiaiano",
      "name": "Chiaiano",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "6f2a7cda",
      "slug": "scampia-secondigliano",
      "name": "Scampia, Secondigliano",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "8aae27cd",
      "slug": "san-pietro-a-patierno-capodichino",
      "name": "San Pietro a Patierno, Capodichino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d368949d",
      "slug": "miano-piscinola",
      "name": "Miano, Piscinola",
      "primary": false,
      "skipSearch": null
    }],
    "552fb310": [{
      "hkey": "ac6285ee",
      "slug": "stella-sanita",
      "name": "Stella, Sanità",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "bf9ea218",
      "slug": "avvocata-materdei",
      "name": "Avvocata, Materdei",
      "primary": true,
      "skipSearch": false
    }],
    "5cad7dde": [{
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "b27752ab",
      "slug": "chiaia-mergellina",
      "name": "Chiaia, Mergellina",
      "primary": true,
      "skipSearch": false
    }],
    "66bb0203": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "66c2f347": [{
      "hkey": "165b94c5",
      "slug": "pianura",
      "name": "Pianura",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "228c3d7e",
      "slug": "agnano-bagnoli-fuorigrotta",
      "name": "Agnano, Bagnoli, Fuorigrotta",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "76d492be",
      "slug": "soccavo-traiano",
      "name": "Soccavo, Traiano",
      "primary": true,
      "skipSearch": false
    }],
    "71bbc55c": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "ac6285ee",
      "slug": "stella-sanita",
      "name": "Stella, Sanità",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "bf9ea218",
      "slug": "avvocata-materdei",
      "name": "Avvocata, Materdei",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "8dcc4f3d": [{
      "hkey": "066dc074",
      "slug": "ponti-rossi-san-carlo-all-arena",
      "name": "Ponti Rossi, San Carlo all'Arena",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "e1d91563",
      "slug": "capodimonte-colli-aminei",
      "name": "Capodimonte, Colli Aminei",
      "primary": true,
      "skipSearch": false
    }],
    "949b1bb1": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "5abb4536",
      "slug": "chiaiano",
      "name": "Chiaiano",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d368949d",
      "slug": "miano-piscinola",
      "name": "Miano, Piscinola",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "95b97773": [{
      "hkey": "066dc074",
      "slug": "ponti-rossi-san-carlo-all-arena",
      "name": "Ponti Rossi, San Carlo all'Arena",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "ac6285ee",
      "slug": "stella-sanita",
      "name": "Stella, Sanità",
      "primary": false,
      "skipSearch": false
    }],
    "a9f62de5": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "aa6bd5aa": [{
      "hkey": "567fc66c",
      "slug": "arenella",
      "name": "Arenella",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "75459368",
      "slug": "vomero",
      "name": "Vomero",
      "primary": true,
      "skipSearch": null
    }],
    "agnano": [{
      "hkey": "228c3d7e",
      "slug": "agnano-bagnoli-fuorigrotta",
      "name": "Agnano, Bagnoli, Fuorigrotta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "avvocata": [{
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b6105371": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "6f2a7cda",
      "slug": "scampia-secondigliano",
      "name": "Scampia, Secondigliano",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "8aae27cd",
      "slug": "san-pietro-a-patierno-capodichino",
      "name": "San Pietro a Patierno, Capodichino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d368949d",
      "slug": "miano-piscinola",
      "name": "Miano, Piscinola",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "b853ebe8": [{
      "hkey": "165b94c5",
      "slug": "pianura",
      "name": "Pianura",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "228c3d7e",
      "slug": "agnano-bagnoli-fuorigrotta",
      "name": "Agnano, Bagnoli, Fuorigrotta",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "76d492be",
      "slug": "soccavo-traiano",
      "name": "Soccavo, Traiano",
      "primary": true,
      "skipSearch": null
    }],
    "b9b96c5f": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "78bf1f66",
      "slug": "zona-industriale",
      "name": "Zona Industriale",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "e156be73",
      "slug": "poggioreale",
      "name": "Poggioreale",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "bagnoli": [{
      "hkey": "228c3d7e",
      "slug": "agnano-bagnoli-fuorigrotta",
      "name": "Agnano, Bagnoli, Fuorigrotta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "barra": [{
      "hkey": "cb8edfa3",
      "slug": "barra-san-giovanni-a-teduccio",
      "name": "Barra, San Giovanni a Teduccio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "barra-ponticelli-san-giovanni-a-teduccio": [{
      "hkey": "cb8edfa3",
      "slug": "barra-san-giovanni-a-teduccio",
      "name": "Barra, San Giovanni a Teduccio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "bb23d973": [{
      "hkey": "066dc074",
      "slug": "ponti-rossi-san-carlo-all-arena",
      "name": "Ponti Rossi, San Carlo all'Arena",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "ac6285ee",
      "slug": "stella-sanita",
      "name": "Stella, Sanità",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "e1d91563",
      "slug": "capodimonte-colli-aminei",
      "name": "Capodimonte, Colli Aminei",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "c26043b3": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "6f2a7cda",
      "slug": "scampia-secondigliano",
      "name": "Scampia, Secondigliano",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "8aae27cd",
      "slug": "san-pietro-a-patierno-capodichino",
      "name": "San Pietro a Patierno, Capodichino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d368949d",
      "slug": "miano-piscinola",
      "name": "Miano, Piscinola",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "c3b532a3": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "b27752ab",
      "slug": "chiaia-mergellina",
      "name": "Chiaia, Mergellina",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "c5fdb134": [{
      "hkey": "78bf1f66",
      "slug": "zona-industriale",
      "name": "Zona Industriale",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "e156be73",
      "slug": "poggioreale",
      "name": "Poggioreale",
      "primary": true,
      "skipSearch": false
    }],
    "chiaia-mergellina-san-ferdinando": [{
      "hkey": "b27752ab",
      "slug": "chiaia-mergellina",
      "name": "Chiaia, Mergellina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "chiaiano-piscinola-marianella-scampia": [{
      "hkey": "5abb4536",
      "slug": "chiaiano",
      "name": "Chiaiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "colli-aminei-capodimonte-ponti-rossi": [{
      "hkey": "e1d91563",
      "slug": "capodimonte-colli-aminei",
      "name": "Capodimonte, Colli Aminei",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "d7c9372c": [{
      "hkey": "6f2a7cda",
      "slug": "scampia-secondigliano",
      "name": "Scampia, Secondigliano",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "8aae27cd",
      "slug": "san-pietro-a-patierno-capodichino",
      "name": "San Pietro a Patierno, Capodichino",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "d368949d",
      "slug": "miano-piscinola",
      "name": "Miano, Piscinola",
      "primary": false,
      "skipSearch": false
    }],
    "e52f54c7": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "b27752ab",
      "slug": "chiaia-mergellina",
      "name": "Chiaia, Mergellina",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "e5d8fa25": [{
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "ee9f9428": [{
      "hkey": "6f2a7cda",
      "slug": "scampia-secondigliano",
      "name": "Scampia, Secondigliano",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "8aae27cd",
      "slug": "san-pietro-a-patierno-capodichino",
      "name": "San Pietro a Patierno, Capodichino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d368949d",
      "slug": "miano-piscinola",
      "name": "Miano, Piscinola",
      "primary": false,
      "skipSearch": null
    }],
    "efca8d16": [{
      "hkey": "228c3d7e",
      "slug": "agnano-bagnoli-fuorigrotta",
      "name": "Agnano, Bagnoli, Fuorigrotta",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "4445ee27",
      "slug": "montecalvario-quartieri-spagnoli",
      "name": "Montecalvario, Quartieri Spagnoli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "e6335e76",
      "slug": "pendino-piazza-garibaldi-mercato",
      "name": "Pendino-Piazza Garibaldi, Mercato",
      "primary": false,
      "skipSearch": null
    }],
    "f013d477": [{
      "hkey": "5abb4536",
      "slug": "chiaiano",
      "name": "Chiaiano",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "9db85895",
      "slug": "camaldoli",
      "name": "Camaldoli",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "bc9e79e7",
      "slug": "rione-alto",
      "name": "Rione Alto",
      "primary": true,
      "skipSearch": false
    }],
    "f4c3d622": [{
      "hkey": "0d003e10",
      "slug": "ponticelli",
      "name": "Ponticelli",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "cb8edfa3",
      "slug": "barra-san-giovanni-a-teduccio",
      "name": "Barra, San Giovanni a Teduccio",
      "primary": true,
      "skipSearch": null
    }],
    "fuorigrotta": [{
      "hkey": "228c3d7e",
      "slug": "agnano-bagnoli-fuorigrotta",
      "name": "Agnano, Bagnoli, Fuorigrotta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fuorigrotta-bagnoli": [{
      "hkey": "228c3d7e",
      "slug": "agnano-bagnoli-fuorigrotta",
      "name": "Agnano, Bagnoli, Fuorigrotta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "fuori-napoli": [{
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "materdei-museo-dante": [{
      "hkey": "bf9ea218",
      "slug": "avvocata-materdei",
      "name": "Avvocata, Materdei",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "mercato-pendino": [{
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "miano": [{
      "hkey": "6f2a7cda",
      "slug": "scampia-secondigliano",
      "name": "Scampia, Secondigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "miano-secondigliano-san-pietro-a-patierno-capodichino": [{
      "hkey": "6f2a7cda",
      "slug": "scampia-secondigliano",
      "name": "Scampia, Secondigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "montecalvario-avvocata-san-giuseppe-porto-pendino-mercato": [{
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "montecalvario-san-giuseppe": [{
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "napoli-centro": [{
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "pianura-soccavo-traiano": [{
      "hkey": "76d492be",
      "slug": "soccavo-traiano",
      "name": "Soccavo, Traiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "piscinola": [{
      "hkey": "5abb4536",
      "slug": "chiaiano",
      "name": "Chiaiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "poggioreale-centro-direzionale-san-lorenzo-vicaria-stazione-centrale": [{
      "hkey": "e156be73",
      "slug": "poggioreale",
      "name": "Poggioreale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "porto": [{
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "posillipo": [{
      "hkey": "864b0f88",
      "slug": "posillipo-marechiaro",
      "name": "Posillipo, Marechiaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "rione-alto-camaldoli": [{
      "hkey": "bc9e79e7",
      "slug": "rione-alto",
      "name": "Rione Alto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "san-carlo-arena-capodimonte-colli-aminei": [{
      "hkey": "e1d91563",
      "slug": "capodimonte-colli-aminei",
      "name": "Capodimonte, Colli Aminei",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-carlo-arena-sanita-stella": [{
      "hkey": "066dc074",
      "slug": "ponti-rossi-san-carlo-all-arena",
      "name": "Ponti Rossi, San Carlo all'Arena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "san-ferdinando": [{
      "hkey": "b27752ab",
      "slug": "chiaia-mergellina",
      "name": "Chiaia, Mergellina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-giovanni-a-teduccio": [{
      "hkey": "cb8edfa3",
      "slug": "barra-san-giovanni-a-teduccio",
      "name": "Barra, San Giovanni a Teduccio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "sanita": [{
      "hkey": "066dc074",
      "slug": "ponti-rossi-san-carlo-all-arena",
      "name": "Ponti Rossi, San Carlo all'Arena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-lorenzo": [{
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-pietro-a-patierno-aeroporto-capodichino": [{
      "hkey": "6f2a7cda",
      "slug": "scampia-secondigliano",
      "name": "Scampia, Secondigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "scampia": [{
      "hkey": "6f2a7cda",
      "slug": "scampia-secondigliano",
      "name": "Scampia, Secondigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "secondigliano": [{
      "hkey": "6f2a7cda",
      "slug": "scampia-secondigliano",
      "name": "Scampia, Secondigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "soccavo": [{
      "hkey": "76d492be",
      "slug": "soccavo-traiano",
      "name": "Soccavo, Traiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "stella": [{
      "hkey": "066dc074",
      "slug": "ponti-rossi-san-carlo-all-arena",
      "name": "Ponti Rossi, San Carlo all'Arena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "vicaria-foria": [{
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "vomero-arenella": [{
      "hkey": "75459368",
      "slug": "vomero",
      "name": "Vomero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "napoli"
    }],
    "vomero-vomero-alto": [{
      "hkey": "75459368",
      "slug": "vomero",
      "name": "Vomero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "zona-industriale-ferrovia": [{
      "hkey": "aa3178c5",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;